const MultiPaymentResultCodes = {
  success: '000',
  errorCodes: [
    '100',
    '101',
    '102',
    '110',
    '111',
    '112',
    '113',
    '121',
    '122',
    '131',
    '132'
  ]
};

export default MultiPaymentResultCodes;



// WEBPACK FOOTER //
// ./src/constants/multi-payment-result-codes.js